import api from "./api.js";
import urls from "./urls.js";
import http from "./http.js";
import cookie from "./cookie.js";
import browser from "./browser.js";
import date from "./date.js";
import tools from "./tools.js";
import config from "./config.js";

export default {
  api,
  urls,
  http,
  cookie,
  browser,
  date,
  tools,
  config,
};
